import { BlocksIconTrash } from 'blocks-nextjs/blocks-web-components/components/icon/icons/trash';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconTrash = createComponent({ react: React, tagName: 'cat-icon-trash', elementClass: BlocksIconTrash });
